// Назва послуги мовою інтерфейсу: nameI18n[lang] -> будь-яка непорожня -> name.
// Порядок фолбеку мов: активна -> pl -> uk -> en -> одиночний name.
export const pickServiceName = (service, lang) => {
  if (!service) return '';
  const i18n = service.nameI18n || {};
  const order = [lang, 'pl', 'uk', 'en'];
  for (const l of order) {
    if (i18n[l] && String(i18n[l]).trim()) return i18n[l];
  }
  return service.name || '';
};
